module.exports = __webpack_public_path__ + "static/media/404.f08b5de3.png";